<template>
  <router-link :to="{ name: 'evento', params: { evento: evento.slug } }" class="ts-card" :title="evento.nombre">
    <v-img
      :src="poster"
      lazy-src="/images/placeholder-poster.jpg"
      class="ts-card-img"
      position="center top"
    >
      <div class="ts-card-fecha" v-if="evento.status != 2 && evento.status != 3 && fecha">
        <span class="ts-card-dia">{{ fecha.dia }}</span>
        <span class="ts-card-mes">{{ fecha.mes }}</span>
        <span class="ts-card-anio">{{ fecha.anio }}</span>
      </div>
      <div class="ts-card-estado ts-card-aplazado" v-if="evento.status == 3">Aplazado</div>
      <div class="ts-card-estado ts-card-cancelado" v-if="evento.status == 2">Cancelado</div>
    </v-img>
    <div class="ts-card-footer">
      <span class="ts-card-nombre">{{ evento.nombre }}</span>
      <span class="ts-btn-card">Comprar boletas</span>
    </div>
  </router-link>
</template>
<script>
import moment from "moment";

export default {
  props: ["evento"],
  computed: {
    poster() {
      const imagenes = this.evento.imagens || [];
      const vertical = imagenes.find(img => img.nombre.includes("vertical"));
      if (vertical) return vertical.url;
      return imagenes.length ? imagenes[0].url : "/images/placeholder-poster.jpg";
    },
    fecha() {
      if (!this.evento.fecha_evento) return null;
      const f = moment(this.evento.fecha_evento);
      return {
        dia: f.format("DD"),
        mes: f.format("MMM").replace(".", "").toUpperCase(),
        anio: f.format("YYYY"),
      };
    },
  },
};
</script>
<style>
.ts-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #0d0d0d;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .18);
  transition: transform .25s, box-shadow .25s;
}
.ts-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, .3);
}
.ts-card-img {
  aspect-ratio: 5 / 6;
  width: 100%;
}
.ts-card-fecha {
  position: absolute;
  top: 12px;
  left: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 48px;
  padding: 4px 8px;
  background: rgba(0, 0, 0, .85);
  border: 1.5px solid #d4a537;
  border-radius: 4px;
  line-height: 1;
}
.ts-card-fecha span {
  font-family: 'Oswald', sans-serif !important;
}
.ts-card-dia {
  color: #fff;
  font-size: 26px;
  font-weight: 700;
}
.ts-card-mes {
  color: #f3d27a;
  font-size: 15px;
  font-weight: 600;
  margin-top: 2px;
}
.ts-card-anio {
  color: #f3d27a;
  font-size: 12px;
  margin-top: 2px;
}
.ts-card-estado {
  position: absolute;
  top: 12px;
  left: 12px;
  padding: 4px 12px;
  border-radius: 4px;
  font-family: 'Oswald', sans-serif !important;
  font-weight: 600;
  text-transform: uppercase;
}
.ts-card-aplazado {
  background: #ffd600;
  color: #000;
}
.ts-card-cancelado {
  background: #d32f2f;
  color: #fff;
}
.ts-card-footer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px 14px;
  background: linear-gradient(180deg, #151515, #0b0b0b);
  margin-top: auto;
}
.ts-card-nombre {
  color: #fff;
  font-family: 'Oswald', sans-serif !important;
  font-size: 15px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: .5px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ts-btn-card {
  display: block;
  text-align: center;
  background: linear-gradient(180deg, #f6dc8c 0%, #d4a537 55%, #b8862a 100%);
  color: #1a1a1a;
  font-family: 'Oswald', sans-serif !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .5px;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 15px;
}
.ts-card:hover .ts-btn-card {
  filter: brightness(1.08);
}
</style>
